<template>
  <div id="app">
    <div class="columns has-background-grey-lighter">
      <div class="column">
        <div class="columns ">
          <div class="column is-12 top-controls">
            <RequestOffer />
          </div>
        </div>
        <Navigation />
        <LoadingEffect v-if="!isLoading"/>
        <div v-if="currentProduct">
          <Summary v-if="currentStep === 'Summary'"/>
          <ProductDetail v-if="currentStep === 'ProductDetails'" />
        </div>
        <div v-else>
          <Products v-if="currentStep === 'Produkte'" />
          <Categories />
        </div>
        <div class="navigation-buttons">
          <NavigationButtons />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Navigation from '@/components/Navigation'
import Summary from '@/components/Summary'
import Categories from '@/components/Categories'
import Products from '@/components/Products'
import ProductDetail from '@/components/ProductDetail'
import NavigationButtons from '@/components/NavigationButtons'
import RequestOffer from '@/components/RequestOffer'
import LoadingEffect from '@/components/loadingEffect.vue'

export default {
  components: { Navigation, Categories, Products, ProductDetail, NavigationButtons, RequestOffer, Summary, LoadingEffect },
  data () {
    return {
      isLoading: true
    }
  },
  computed: {
    currentStep () {
      return this.$store.state.currentStep
    },
    categories () {
      return this.$store.state.categories
    },
    currentProduct () {
      return this.$store.state.currentProduct
    }
  },
  mounted () {
    this.$store.dispatch('setCategories')
    this.$store.dispatch('setProducts')
  }
}
</script>

<style lang="sass" scoped>
@import "@/assets/sass/main.sass"

.navigation-buttons
  margin-top: $base-gap * 10
  margin-bottom: $base-gap * 10
  

#app
  background-color: $grey-lighter
  width: 100%

.top-controls
  align-items: center
  align-content: center
  padding: 5px
  margin: 0

</style>
